import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiscountInfoComponent } from './discount-info/discount-info.component';


@NgModule({
    declarations: [
        DiscountInfoComponent,
    ],
    exports: [
        DiscountInfoComponent,
    ],
    imports: [
        CommonModule,
    ]
})
export class ComponentsModule { }
